import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Ana Laura G.',
  city: 'Bogotá',
  text: 'Pasé de 10 vistos al día a cerrar 4 ventas en mi primera semana usando el método A.R.P.A.'
}, {
  name: 'Carolina M.',
  city: 'Medellín',
  text: 'Ya no me da ansiedad cuando me preguntan el precio. Sé exactamente qué responder.'
}, {
  name: 'Diana P.',
  city: 'Cali',
  text: 'Los guiones anti-visto son oro puro. Recuperé 3 ventas que daba por perdidas.'
}, {
  name: 'Valentina R.',
  city: 'Barranquilla',
  text: 'Reduje mi tiempo en el celular a la mitad y estoy vendiendo más. El prompt de ChatGPT es magia.'
}, {
  name: 'Juliana C.',
  city: 'Bucaramanga',
  text: 'Por fin dejé de sonar como un catálogo andante. Mis clientas me responden súper bien.'
}, {
  name: 'María F.',
  city: 'Pereira',
  text: 'El tablero de seguimiento me hizo dar cuenta de cuánta plata estaba dejando en la mesa.'
}, {
  name: 'Andrea S.',
  city: 'Bogotá',
  text: 'Vale cada peso. Solo con la primera venta que cerré ya recuperé la inversión.'
}, {
  name: 'Camila T.',
  city: 'Medellín',
  text: 'Me daba terror vender por chat. Ahora siento que tengo el control de la conversación.'
}, {
  name: 'Laura V.',
  city: 'Manizales',
  text: 'El diagnóstico express me mostró el error que llevaba cometiendo 2 años.'
}];
export function Testimonials() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center" data-id="element-220">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-graphite mb-4" data-id="element-221">
          Emprendedoras que ya no ruegan por ventas
        </h2>
        <p className="text-gray-500 text-sm" data-id="element-222">
          * Resultados pueden variar según la implementación
        </p>
      </div>

      {/* Infinite Ticker */}
      <div className="relative w-full flex overflow-hidden no-scrollbar" data-id="element-223">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10" data-id="element-224"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10" data-id="element-225"></div>

        <div className="flex animate-ticker whitespace-nowrap gap-6 py-4 px-6" data-id="element-226">
          {/* Double the array for seamless looping */}
          {[...TESTIMONIALS, ...TESTIMONIALS].map((testimonial, i) => <div key={i} className="w-80 md:w-96 flex-shrink-0 bg-surface border border-gray-100 rounded-2xl p-6 shadow-sm whitespace-normal" data-id="element-227">
              <div className="flex items-center gap-1 mb-3" data-id="element-228">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-229" />)}
              </div>
              <p className="text-gray-700 font-medium mb-6 italic" data-id="element-230">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-231">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-232">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-233">
                  <p className="font-bold text-graphite text-sm" data-id="element-234">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-235">{testimonial.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}